
import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Steps, message, Popconfirm, Space, Row, Skeleton } from "antd";
import { SaveButton, ModalComponent, trans, SelectMultiWithSearch } from "@comps/components"
import { makeRequest, makeRequestStateless } from "@utils/helpers";
import { getCompanyRelatedDataReq } from "@mods/common/requests";
import { applyLeaveTypeReq, getPreviewDataReq, getReleatedDataReq } from '../requests'
import { Commons, Const } from "../../../constants";
import FilterSelectEmployees from "@mods/common/FilterSelectEmployees"
import { createSelectList } from '@comps/commonFunctions';
import { getLeaveRequestTooltip } from "../../../common/leaveTooltips";
import LeaveTypeAssignmentPreview from "./LeaveTypeAssignmentPreview";
import LeavePolicyReview from "./LeavePolicyReview";
import { buildLeavePolicySummary } from "./leavePolicyReview";
import { makeFieldLabel } from "@utils/fieldTooltips";
//const moment = require('moment');
const langKey = Const["leaveType"].lngKey
const formName = "applyLeaveType";

const ApplyLeaveType = (props) => {

  //========initial child states===============
  const [preEmployeesFilter, setPreEmployeesFilter] = useState({})
  const [unSelectedEmployees, setUnSelectedEmployees] = useState([])
  const [selectedEmployees, setSelectedEmployees] = useState([])
  //============================
  const [, setLoader] = useState(false);
  const [saving, setsaving] = useState(false)
  const [loading, setloading] = useState(true)
  const [companyRelatedData, setCompanyRelatedData] = useState([]);
  const selectedEmployments = [];
  const [previewData, setPreviewData] = useState([]);
  const [form] = Form.useForm();
  //------------intitial steps state---------
  const [firstStepData, setFirstStepData] = useState(null);
  const [currentStep, setCurrent] = useState(0);
  const [leaveTypes, setLeaveTypes] = useState([])
  const [leaveTypeRecords, setLeaveTypeRecords] = useState([])
  const [empIds, setEmpIds] = useState([])
  const selectedLeaveTypeIds = Form.useWatch('leave_type_ids', form) || firstStepData?.leave_type_ids || [];
  useEffect(() => {
    getRemoteData()
    setData()
    // eslint-disable-next-line
  }, []);
  const getRemoteData = () => {
    makeRequestStateless(getCompanyRelatedDataReq, null, ongetCompanyRelatedDataReq, null);
    makeRequestStateless(getReleatedDataReq, false, onGetLeaveTypeRelatedData, null);
  }
  const ongetCompanyRelatedDataReq = (response) => {
    setCompanyRelatedData(response)
    setloading(false)
  }
  const onGetLeaveTypeRelatedData = (response) => {
    if (response.all_leave_types) {
      const records = mergeLeaveTypeRecords(props.record || [], response.all_leave_types);
      setLeaveTypeRecords(records)
      setLeaveTypes(createSelectList(records))
    }
  }

  const setData = () => {
    if (!props) {
      return;
    }
    const records = props.record || [];
    if (records.length === 0) {
      return;
    }
    setLeaveTypeRecords(records)
    setLeaveTypes(createSelectList(records))
    if (props.initialLeaveTypeIds && props.initialLeaveTypeIds.length > 0) {
      const initialData = { leave_type_ids: props.initialLeaveTypeIds };
      setFirstStepData(initialData);
      form.setFieldsValue(initialData);
    }
  }
  //=================Submit First Step 1==============================================
  const stepOne = () => {
    return (
      <>
        <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmitFirstStep } initialValues={ firstStepData } scrollToFirstError>
          <Form.Item name='leave_type_ids'
            label={ fieldLabel("leave_type_ids", trans(`${langKey}.leave_type_id`)) }
            rules={ rules.leave_type_id }>
            <SelectMultiWithSearch
              options={ leaveTypes }
              placeholder={ trans(`${langKey}.leave_type_id`) }
            />
          </Form.Item>
          <LeaveTypeSelectionSummary
            selectedIds={ selectedLeaveTypeIds }
            leaveTypeRecords={ leaveTypeRecords }
          />
          <Row justify="end">
            <Space>
              <Button className="button-next" type="primary" htmlType="submit">
                Next
              </Button>
            </Space>
          </Row>
        </Form>
      </>
    )
  }
  const onSubmitFirstStep = (data) => {
    if (!data.leave_type_ids || data.leave_type_ids.length === 0) {
      message.error('Please select at least one leave policy.');
      return;
    }
    setFirstStepData(data);
    setCurrent(currentStep + 1)
  }
  // ------------------------------------
  //=====================On Submit Second Step===========================
  const setSelectedEmploymentsIds = (employments) => {
    if (!employments.employment_ids || employments.employment_ids.length === 0) {
      message.error('Please select at least one employee.');
      return;
    }
    setEmpIds(employments)
    let payload = { leave_type_ids: firstStepData.leave_type_ids, employment_ids: employments.employment_ids };
    makeRequest(setLoader, getPreviewDataReq, payload, onGetPreview, null);
  }
  const onGetPreview = (response) => {
    setPreviewData(response)
    setCurrent(currentStep + 1)
  }
  const onCancel = () => {
    props.onCompleted(false);
  }
  const onBack = () => {
    setCurrent(currentStep - 1)
  }
  //==============================Save all Data=========================================
  const onSubmit = () => {
    if (!canApplyPreview(previewData)) {
      message.info('No changes are needed. The selected employees already have these leave policies and quotas.');
      return;
    }
    const payload = {
      leave_type: { leave_type_ids: firstStepData.leave_type_ids, employment_ids: empIds.employment_ids }
    };
    makeRequest(setLoader, applyLeaveTypeReq, payload, onSuccess, onError);
    setsaving(true)
  }

  const onSuccess = (data, res) => {
    setsaving(false)
    if (data.errors && data.errors.length > 0) {
      message.warning(`${data.summary?.applied || 0} applied, ${data.errors.length} skipped or failed. Review the result list.`);
    }
    else {
      message.success(`Leave policies applied to ${data.summary?.applied || 0} employee-policy selection(s).`);
    }
    props.onCompleted(data);
  }
  const onError = (err, res) => {
    setsaving(false)
    if (res.message) {

      message.error(res.message);
    }

    message.error(res.response.data.message);
  }
  const footer = [];
  //================================Main Modal Component==================================
  return (
    <ModalComponent top={ 20 } width={ 1200 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ <>
        <p style={ { paddingLeft: 75, marginTop: -30 } }>{ trans(`${langKey}.applyLeave`) }</p>
        <Steps
          className="steps-style"
          current={ currentStep }
          onChange={ setCurrent }
        >
          <Steps.Step className="steps-step1" title={ "Leave Type" } style={ { paddingLeft: 50 } } />
          <Steps.Step className="steps-step2" title={ "Select Employees" } disabled={ firstStepData ? false : true } />
          <Steps.Step className="steps-step3" title={ "Finalise" } disabled={ true } />
        </Steps>
      </> }
      visible={ true } onCancel={ () => props.onCompleted(false) } footer={ footer }>
      <Skeleton loading={ loading }>

        { currentStep === 0 ?
          stepOne()
          : currentStep === 1 ?
            <FilterSelectEmployees setSelectedEmploymentsIds={ setSelectedEmploymentsIds } companyRelatedData={ companyRelatedData } onCancel={ onCancel } onBack={ onBack }
              employment_ids={ selectedEmployments }
              moduleName='leaveType' selected={ selectedEmployees } unSelected={ unSelectedEmployees } preFilters={ preEmployeesFilter } setSelected={ setSelectedEmployees } setUnselected={ setUnSelectedEmployees } setPrefilters={ setPreEmployeesFilter }
            />
            : currentStep === 2 ?
              <>
                { !canApplyPreview(previewData) && <Alert className="da-mb-16" type="warning" showIcon message="Nothing to apply" description="These employees already have the selected policies, or they do not meet the policy rules. Review the reasons below or go back to change your selection." /> }
                <LeaveTypeAssignmentPreview previewData={ previewData } />
              </> : '' }
        {
          currentStep === 2 ?
            <Row justify="end">
              <Space>
                <Button className="button-back" onClick={ () => setCurrent(currentStep - 1) } disabled={ currentStep > 0 ? false : true }>
                  <span style={ { color: "#4079FC" } }>Back</span>
                </Button>

                <Popconfirm
                  title="Apply these leave policies?"
                  description="The quotas shown in the review will be added or updated for the selected employees."
                  okText="Apply policies"
                  cancelText="Cancel"
                  onConfirm={ onSubmit }
                  disabled={ !canApplyPreview(previewData) }
                >
                  <SaveButton className="button-next" form={ formName } key="create_button" loading={ saving } disabled={ !canApplyPreview(previewData) } />
                </Popconfirm>
              </Space>
            </Row>
            : ''
        }
      </Skeleton>

    </ModalComponent>
  )
}

export default ApplyLeaveType
const rules = {
  leave_type_id: [
    { required: true, message: trans(`${langKey}.leave_type_id.req`) },
  ],

}

const formLayout = {
  // layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 14, offset: 2 },
  labelAlign: "left"
}

const fieldLabel = makeFieldLabel(getLeaveRequestTooltip, { namespace: formName, label: (key) => trans(`${langKey}.${key}`) });
const canApplyPreview = (previewData) => {
  const summary = previewData?.summary || {};
  return (summary.created || 0) + (summary.updated || 0) + (summary.assigned || 0) > 0;
};

const mergeLeaveTypeRecords = (preferredRecords = [], fallbackRecords = []) => {
  const map = new Map();
  fallbackRecords.forEach((record) => {
    map.set(String(record.id || record.value), record);
  });
  preferredRecords.forEach((record) => {
    map.set(String(record.id || record.value), record);
  });
  return Array.from(map.values());
};

const LeaveTypeSelectionSummary = ({ selectedIds, leaveTypeRecords }) => {
  if (!selectedIds || selectedIds.length === 0) {
    return (
      <Alert
        className="da-mb-16"
        type="info"
        showIcon
        message="Select leave policies to review their rules"
        description="The summary will show allowed days, eligibility, request rules, and period source before you choose employees."
      />
    );
  }

  const selectedRecords = leaveTypeRecords.filter((record) => selectedIds.some((id) => String(id) === String(record.id || record.value)));

  if (selectedRecords.length === 0) {
    return null;
  }

  return (
    <div className="da-mb-16">
      { selectedRecords.map((record) => (
        <LeavePolicyReview
          key={ record.id || record.value }
          compact
          summary={ buildLeavePolicySummary({
            leave_type: record,
            pre_condition: record.pre_condition || {},
          }) }
        />
      )) }
    </div>
  );
};
